import React from 'react';

import { useCampaignCardContext } from '../../campaign-card-context';

import {
  Behavior,
  CaptionStrongText,
  CaptionText,
  FontEmphasis,
  TitleSmallText,
} from '@prisjakt/ui/text/variants';
import { MediumDown } from 'src/ui/block';
import Rating from 'src/components/rating';
import { Badges } from './badges';
import { Prices } from './prices';

import {
  StyledCardContent,
  StyledFirstSection,
  StyledSecondSection,
} from './styles';

type Props = {
  className?: string;
};

export const CampaignCardContent = (props: Props) => {
  const { className } = props;
  const { category, name, price, rating, reviewsCount, store } =
    useCampaignCardContext();

  return (
    <StyledCardContent className={className}>
      <StyledFirstSection>
        {category?.name && (
          <CaptionText
            behavior={Behavior.OnelineEllipsis}
            emphasis={FontEmphasis.MEDIUM}
          >
            {category.name}
          </CaptionText>
        )}

        <TitleSmallText
          behavior={Behavior.TwolineEllipsis}
          containerProps={{ 'data-test': 'ProductName' }}
        >
          {name}
        </TitleSmallText>

        {rating && rating > 0 ? (
          <Rating rate={rating} count={reviewsCount} showCounterAs="number" />
        ) : null}
      </StyledFirstSection>

      <StyledSecondSection>
        <Badges />

        <Prices />

        {store && (
          <CaptionStrongText
            emphasis={store.featured ? FontEmphasis.HIGH : FontEmphasis.LOW}
          >
            {store.name}
          </CaptionStrongText>
        )}

        {price?.previousPriceText && (
          <MediumDown>
            <CaptionText>* {price.previousPriceText}</CaptionText>
          </MediumDown>
        )}
      </StyledSecondSection>
    </StyledCardContent>
  );
};
